var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }